import { Component, OnInit, OnDestroy } from '@angular/core';

//Services
import { ArqueoCajaService } from '../../../services/arqueo-caja.service';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { SessionService } from '../../../services/session.service';

//Modelos
import { ArqueoCaja } from '../../../models/arqueo_caja';
import { AsignacionCaja } from '../../../models/asignacion-caja';

//Otros
import { SweetMessage } from '../../../config/sweet-message';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { ReposicionCajaModalComponent } from '../../modals/reposicion-caja-modal/reposicion-caja-modal.component';
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: 'app-punto-venta-list',
  templateUrl: './punto-venta-list.component.html',
  styleUrls: ['./punto-venta-list.component.css'],
  providers: [
	ArqueoCajaService,
	AsignacionCajaService
  ]
})
export class PuntoVentaListComponent implements OnInit, OnDestroy {
	public msg: SweetMessage;
	public loading: boolean;
	public asignaciones: Array<AsignacionCaja>;
	public arqueos: Array<ArqueoCaja>;
	public bsModalRef: BsModalRef;
	private _modelSubscription: Subscription;

	constructor(
		public arqueoService: ArqueoCajaService,
		public asignacionService: AsignacionCajaService,
		private modalService: BsModalService,
		private ss: SessionService,
	) { 
		this.loading = false;
		this.arqueos = [];
		this.asignaciones = [];
	}

	ngOnInit() {
		this.msg = new SweetMessage();
		this.loading = true;
		this.getArqueos().then(
			res => this.loading = false,
			err => this.loading = false
		);

		this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
			this.loading = true;
			this.getArqueos().then(
				res => this.loading = false,
				err => this.loading = false
			);
		});
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	getArqueos(){
		return new Promise((resolve, reject) => {
			let today = moment().format("YYYY-MM-DD");
			this.asignacionService.getAll("?fecha=" + today + "&embed=caja,usuario,arqueos").subscribe(
			//this.asignacionService.getAll("?embed=caja,usuario,arqueos").subscribe(
				res => {
					this.asignaciones = res.data;
					resolve();
				},
				err => {
					this.arqueos = [];
					reject(err);
				}
			);
		});
	}

	getSumArqueos($asignacion: AsignacionCaja){
		let total = 0;
		if($asignacion.tipo == 'C'){
			$asignacion.arqueos.forEach(arqueo => {
				if(arqueo.tipo == 'C'){
					total += parseFloat(arqueo.valor.toString());
				}
			});
		}
		return total;
	}

	getTipo($tipo){
		if($tipo == 'A'){
			return "Aperturada";
		}
		else{
			return "Cerrada";
		}
	}
	
	onReport(id){
		const initialState = {route: "arqueo/" + id, qs: "?dbname=" + this.ss.getData('dbname') +"&usuario_id=" + this.ss.getData('usuario_id')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onReposicion(id){
		const initialState = { asignacion_id: id };
		this.bsModalRef = this.modalService.show(ReposicionCajaModalComponent, Object.assign({backdrop: 'static'}, {initialState}));
	}

	getValorTipo(asignacion, tipo){
		for(let item of asignacion.arqueos ){
			if(item.tipo == tipo){
				return item.valor;
			}
		}

		return 0;
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/punto-venta-list/punto-venta-list.component.ts